import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchByPage(data) {
    return request({
        url: "/base/operateLogManage/findByPage",
        method: "post",
        headers: {type: "json"},
        data
    });
}

/**
 * 获取模块列表
 * @param {*} data
 */
export function FetchModuleTree() {
    return request({
        url: "/base/operateLogManage/getModuleTree",
        method: "post"
    });
}


/**
 * 获取用户列表
 * @param {*} data
 */
export function FetchUserTree() {
    return request({
        url: "/base/operateLogManage/getUserTree",
        method: "post"
    });
}